module.exports = {"350123100":"凤山镇","350123101":"松山镇","350123102":"起步镇","350123103":"中房镇","350123104":"飞竹镇","350123105":"鉴江镇","350123200":"白塔乡","350123201":"洪洋乡","350123202":"西兰乡","350123203":"霍口畲族乡","350123204":"碧里乡","350123500":"罗源湾"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350123.json
// module id = 1073
// module chunks = 0